<template>
  <div class="card">
    <div class="card-header">
      <h3 class="h5 mb-0 font-weight-bold">
        Agents
      </h3>
    </div>
    <div class="card-body">
      <p class="mb-4">
        Associate one or more MLS Agent Profiles with your accessRedwood user account.
        <b>Note:</b> To claim an agent profile, you must have access to the email in the profile.
      </p>
      <table class="table">
        <thead>
          <tr>
            <th>Agent</th>
            <th>Confirmed</th>
            <th>Primary</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="agent in agentData">
            <td>
              <div><b>{{ agent.name }}</b></div>
              <div><a :href="`mailto:${agent.email}`">{{ agent.email }}</a></div>
              <div class="">{{ getOfficeName(agent) }}</div>
              <div>
                <code>{{ (agent.mls_connection || '').toUpperCase() }} #{{ agent.mls_id }}</code>,
                <code>REDWOOD #{{ agent.id }}</code>
              </div>
              <div class="small text-muted">{{ agent.mls_key }}</div>
            </td>
            <td v-if="agent.owner_confirmed_at">
              {{ agent.owner_confirmed_at }}
            </td>
            <td v-if="!agent.owner_confirmed_at" class="text-danger">
              Unconfirmed
            </td>
            <td>
              &mdash;
            </td>
            <td>
              <button class="btn btn-lg btn-link text-muted py-0" @click.prevent="unclaim(agent)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <form class="form-group mb-0" v-if="addAgent" @submit.prevent="search()">
        <label for="new_agent_ref">Add new agent</label>
        <div class="mb-3">
          <div class="d-flex">
            <input
              id="new_agent_ref"
              type="text"
              class="form-control"
              placeholder="Search by name, email address, MLS ID..."
              v-model="query"
            >
            <button type="submit" class="btn btn-primary ml-2" :disabled="this.searching">
              {{ searching ? 'Searching...' : 'Search' }}
            </button>
          </div>
          <small class="text-danger" v-if="searchError">
            {{ searchError }}
          </small>
        </div>
        <div v-if="results.length">
          <div v-for="(result, i) in results" class="">
            <hr>
            <div class="media">
              <div class="media-body">
                <div>
                  <b>{{ result.name }}</b>
                  {{ result.email }}, {{ getOfficeName(result) }}
                </div>
                <small>
                  {{ (result.mls_connection || '').toUpperCase() }}
                  #{{ result.mls_id }},
                  {{ result.mls_key }}
                  <i class="fa fa-key"></i>
                </small>
              </div>
              <div class="media-right text-right">
                <button class="btn btn-link" @click.prevent="claim(results[i])" :disabled="results[i].claiming">
                  {{ results[i].claiming ? 'Claiming...' : 'Claim' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div v-if="!addAgent">
        <hr>
        <div class="d-flex">
          <button class="btn btn-link" @click.prevent="addAgent = true">
            <i class="fa fa-plus mr-1"></i>
            Add Agent
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get, filter } from 'lodash'
import { searchAgents, claimAgent, unclaimAgent } from '@/api'
import wait from '@/lib/wait'
import alertify from 'alertify.js'

export default {
  props: {
    agents: {
      type: Array,
      default () {
        return []
      }
    }
  },
  computed: {
    dirty () {

    }
  },
  data () {
    return {
      searching: false,
      searchError: false,
      addAgent: false,
      agentData: this.agents,
      query: null,
      results: []
    }
  },
  methods: {
    getOfficeName (agent) {
      return (get(agent, 'office.name') + ' ' + get(agent, 'office.city')).trim()
    },
    claim (agent) {
      agent.claiming = true
      wait.saving()
      claimAgent(agent.id)
        .then((response) => {
          this.agentData = response.data
          this.query = null
          this.addAgent = false
          this.results = []
          wait.saved()
        })
        .catch((response) => {
          wait.oops()
        })
    },
    unclaim (agent) {
      wait.deleting()
      alertify.confirm('Are you sure you want to unclaim this agent profile?', () => {
        unclaimAgent(agent.id)
          .then((response) => {
            this.agentData = response.data
            wait.deleted()
          })
          .catch((response) => {
            wait.oops()
          })
      })
    },
    search () {
      if (this.searching) {
        return false
      }

      if (this.query) {
        this.searchError = false
        this.searching = true
        searchAgents(this.query)
          .then((response) => {
            let results = []
            if (response.data.total > 0) {
              results = filter(response.data.data, (result) => {
                return !result.user_id && result.redwood
              })
            }
            if (results.length > 0) {
              this.results = results.slice(0, 5)
            } else {
              this.results = []
              this.searchError = 'No unclaimed agents found for your search.'
            }
            this.searching = false
          })
          .catch((response) => {
            this.results = []
            wait.oops()
            this.searching = false
            this.searchError = 'There was an error while searching. Please try again.'
          })
      }
    }
  }
}
</script>